import { TOKEN_EXCHANGE } from './constants'

import runtimeConfig from '@config/runtime'
import storage from '@utils/storage'

const tokenExchange = ({ grantType, code, refreshToken, silent, next }) => ({
  type: TOKEN_EXCHANGE,
  payload: {
    client: 'identity',
    request: {
      method: 'post',
      url: '/token',
      data: new URLSearchParams({
        grant_type: grantType,
        client_id: runtimeConfig.identityClientId,
        redirect_uri: `${
          runtimeConfig.identityCallbackURL
        }/?next=${encodeURIComponent(next)}${silent ? '&silent=true' : ''}`,
        ...(code && { code }),
        ...(refreshToken && { refresh_token: refreshToken })
      }).toString()
    }
  }
})

export const logout = ({ refreshToken }) => ({
  type: TOKEN_EXCHANGE,
  payload: {
    client: 'identity',
    request: {
      method: 'post',
      url: '/logout',
      data: new URLSearchParams({
        client_id: runtimeConfig.identityClientId,
        ...(refreshToken && { refresh_token: refreshToken })
      }).toString()
    }
  }
})

const saveToken = (payload) => {
  const {
    access_token: accessToken,
    refresh_token: refreshToken,
    refresh_expires_in: refreshTokenExpires,
    expires_in: accessTokenExpires
  } = payload

  storage.set('accessToken', accessToken)
  storage.set('refreshToken', refreshToken)
  storage.set('refreshTokenExpires', refreshTokenExpires)
  storage.set('accessTokenExpires', accessTokenExpires)
}

const clearToken = () => {
  storage.remove('accessToken')
  storage.remove('refreshToken')
  storage.remove('refreshTokenExpires')
  storage.remove('accessTokenExpires')
}

export const refreshToken = () => async (dispatch) => {
  const refreshToken = storage.get('refreshToken')

  if (!refreshToken) {
    return Promise.reject(new Error('No refresh token'))
  }

  return dispatch(
    tokenExchange({
      grantType: 'refresh_token',
      refreshToken
    })
  )
    .then((action) => {
      saveToken(action.payload.data)
      return Promise.resolve(action.payload.data)
    })
    .catch((e) => {
      clearToken()
      return Promise.reject(e)
    })
}

export const handleCallback = ({ code, replace, silent, next }) => async (
  dispatch,
  getState
) => {
  await dispatch(
    tokenExchange({ grantType: 'authorization_code', code, silent, next })
  )
    .then((action) => {
      saveToken(action.payload.data)

      if (!silent) {
        replace(next)
      }

      storage.remove('userToken')
      window.parent.postMessage({
        action: 'login',
        status: 'success',
        payload: action.payload.data
      })
    })
    .catch((e) => {
      return false
    })
}
